import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import Header from './Header';
import Footer from './Footer';
import './BlogDetails.css';

const Blogdetails = () => {
  const [blogPost, setBlogPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { id } = useParams();

  useEffect(() => {
    window.scrollTo(0, 0);
    const fetchBlogPost = async () => {
      try {
        const response = await fetch(`https://api.ndtechland.com/api/HomeApi/GetBlogById?Id=${id}`);
        const data = await response.json();

        if (data.status === 200) {
          setBlogPost({
            title: data.data.title,
            content: data.data.content,
            author: data.data.addedBy || 'ND Connect Team',
            category: data.data.category,
            date: data.data.createdAt ? new Date(data.data.createdAt).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' }) : '',
            image: `https://api.ndtechland.com/image/${data.data.blogImage}`,
          });
        } else {
          setError('Failed to fetch blog post');
        }
      } catch (err) {
        setError('An error occurred while fetching the blog post');
      } finally {
        setLoading(false);
      }
    };

    fetchBlogPost();
  }, [id]);

  if (loading) {
    return (
      <>
        <Header />
        <div className="blog-details-state">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  if (error || !blogPost) {
    return (
      <>
        <Header />
        <div className="blog-details-state">
          <p className="text-danger">{error || 'No blog post found.'}</p>
          <Link to="/blog" className="blog-back-btn mt-3">
            <FaArrowLeft /> <span>Back to Blogs</span>
          </Link>
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Header />
      <section className="blog-details-section">
        <div className="container">
          <div className="blog-details-top-bar">
            <Link to="/blog" className="blog-back-btn">
              <FaArrowLeft />
              <span>Back to Blogs</span>
            </Link>
          </div>

          <div className="blog-article-wrapper">
            <div className="blog-article-head-box">
              {blogPost.category && (
                <span className="blog-article-badge">{blogPost.category}</span>
              )}
              <h1 className="blog-article-title">{blogPost.title}</h1>
            </div>

            {blogPost.image && (
              <div className="blog-article-hero-img-wrap">
                <img
                  src={blogPost.image}
                  alt={blogPost.title}
                  className="blog-article-hero-img"
                />
              </div>
            )}

            <div
              className="blog-article-prose"
              dangerouslySetInnerHTML={{ __html: blogPost.content }}
            />
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default Blogdetails;
